import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { getDefaultLanguage, getSupportedLanguageCodes, type SupportedLanguage } from './languages';

const STORAGE_KEY = 'admin-language';

const initI18n = async () => {
  const defaultLanguage = getDefaultLanguage();

  await i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      lng: defaultLanguage,
      fallbackLng: defaultLanguage,
      debug: import.meta.env.DEV,

      backend: {
        loadPath: '/locales/{{lng}}.json',
      },

      interpolation: {
        escapeValue: false,
      },

      react: {
        useSuspense: false,
      },
    });

  loadSavedLanguage();
};

const loadSavedLanguage = () => {
  try {
    const savedLanguage = localStorage.getItem(STORAGE_KEY);
    const supportedLanguages = getSupportedLanguageCodes();
    if (savedLanguage && supportedLanguages.includes(savedLanguage as SupportedLanguage)) {
      void i18n.changeLanguage(savedLanguage as SupportedLanguage);
    }
    // If no saved language or invalid language, keep default language (already set)
  } catch (error) {
    console.warn('Could not load saved language, keeping default language:', error);
  }
};

export { initI18n };
